export default (params) => ({
  trigger: {
    name: 'product_collection.close_collection',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'multi_discriminant_selector',
          'drop_down_selector',
          'drop_down_panel',
        ],
      },
    },
    event: {
      name: 'close',
    },
  },
});
